import React from 'react'
import CommonNavbar from '../../components/CommonNavbar/CommonNavbar'
import CommonFooter from '../../components/CommonFooter/CommonFooter'

const AgriInputStore = () => {
  return (
    <>
      <CommonNavbar />
      <div className='py-5'>
        <div className='container px-md-5'>
          <div className='p-8 bg-white text-gray-800 leading-relaxed'>
            {/* Heading */}
            <h1 className='text-3xl font-bold text-green-900 mb-6 clr_dark_green'>
              FC Agri Input Store
            </h1>

            {/* Intro */}
            <p className='mb-6'>
              Farmer’s City (FC) Agri Input Store is a cornerstone of our
              mission to empower farmers with access to high-quality
              agricultural inputs, equipment, and services. These stores serve
              as hubs for farmer training, procurement of essential supplies,
              and market linkages. Our goal is to revolutionize the agri-input
              industry by providing a seamless blend of physical and digital
              services tailored to the needs of smallholder farmers.
            </p>

            {/* Services */}
            <h2 className='text-2xl font-semibold text-green-900 mb-4 clr_dark_green'>
              Services Offered at FC Agri Input Store
            </h2>
            <ul className='list-disc list-inside mb-6 space-y-2'>
              <li>
                <strong>Visit the Nearest Store:</strong> Locate your nearest FC
                Agri Input Store either through our mobile app or website.
              </li>
              <li>
                <strong>Explore Products:</strong> Browse through a diverse
                range of agri-input products available at competitive prices.
              </li>
              <li>
                <strong>Consult Experts:</strong> Seek guidance from our
                knowledgeable staff on product selection, usage instructions,
                and best practices.
              </li>
              <li>
                <strong>Place Orders:</strong> Place orders conveniently either
                in-store or through our digital platform for a hassle-free
                shopping experience.
              </li>
              <li>
                <strong>Avail Additional Services:</strong> Take advantage of
                ancillary services such as soil testing, crop advisory, quality
                assessment, and subscription services offered at the store.
              </li>
            </ul>

            {/* Franchise Opportunities */}
            <h2 className='text-2xl font-semibold text-green-900 mb-4 clr_dark_green'>
              Franchise Opportunities
            </h2>
            <ul className='list-disc list-inside mb-6 space-y-2'>
              <li>Initial investment guidance</li>
              <li>Training programs for store management</li>
              <li>Marketing and promotional assistance</li>
              <li>Access to a wide network of suppliers and partners</li>
            </ul>

            {/* Closing */}
            <p>
              Join us in revolutionizing the agri-input industry and empowering
              farmers across the country through our innovative phygital model
              that combines the best of physical stores and digital platforms.
            </p>
          </div>
          <CommonFooter />
        </div>
      </div>
    </>
  )
}

export default AgriInputStore
